import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserStorageService} from '../../services/user-storage-service/user-storage.service';
import {Router} from '@angular/router';
import {ControlDesk} from '../../models/turns-models/control-desk.model';
import {map, tap} from 'rxjs/internal/operators';
import {TurnsService} from '../../services/turns-services/turns-service/turns.service';
import {MaintenanceService} from '../../services/maintenance-service/maintenance.service';
import {CommunicationService} from '../../services/communication-service/communication.service';
import {LocationDesk} from '../../models/turns-models/location-desk.model';
import { APP_CONFIG } from 'src/app/config';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-advance-desk-screen',
  templateUrl: './advance-desk-screen.component.html',
  styleUrls: ['./advance-desk-screen.component.scss']
})
export class AdvanceDeskScreenComponent implements OnInit, OnDestroy {

  version: string = APP_CONFIG.appVersion;
  companyImage: string;
  selectedDesk: ControlDesk;
  selectedLocation: LocationDesk;
  selectedLocationClosed = false;

  currentTurn: string;
  currentDeskName: string;
  currentWaitingAndAttendingTurns;

  listenDeskAdvanceObjectSubscription: Subscription;
  listenUpdateDesksSubscription: Subscription;
  listenTurnTakenSubscription: Subscription;

  constructor(private maintenanceService: MaintenanceService,
              private communicationService: CommunicationService,
              private userStorageService: UserStorageService,
              private turnsService: TurnsService,
              private router: Router) {
    this.selectedDesk = this.userStorageService.getSelectedDesk();
    this.selectedLocation = this.userStorageService.getSelectedLocationDesk();
    this.checkDeskLocationStatus();
    console.log('Desk: ' + JSON.stringify(this.selectedDesk));
    console.log('Location: ' + JSON.stringify(this.selectedLocation));
    if (this.selectedDesk) {
      this.getControlDesks();
    } else if (this.selectedLocation) {
      this.updateCurrentLocation();
    }
  }

  private checkDeskLocationStatus() {
    if (this.selectedLocation) {
      this.selectedLocationClosed = this.selectedLocation.status === 'CLOSED';
      console.log('Location is closed: ' + this.selectedLocationClosed);
    }
  }

  ngOnInit() {
    this.maintenanceService.isRegistered().pipe(
      map(registered => {
        if (!registered['isRegistered']) {
          this.router.navigate(['/']);
        } else {
          this.userStorageService.setContext(registered['context']);
          this.turnsService.getCompanyInfo(this.userStorageService.getCompanyInternalId()).pipe(
            tap(o => this.companyImage = o['imageXl'])
          ).subscribe();
          this.selectedDesk = this.userStorageService.getSelectedDesk();
          this.selectedLocation = this.userStorageService.getSelectedLocationDesk();
          if (this.selectedDesk === null && this.selectedLocation === null) {
            this.router.navigate(['/admin']);
          } else {
            if (this.selectedDesk) {
              this.getControlDesks();
            } else if (this.selectedLocation) {
              this.updateCurrentLocation();
            }
          }
          this.communicationService.listenCommunications();
        }})
    ).subscribe();

    this.listenDeskAdvanceObjectSubscription = this.turnsService.listenDeskAdvanceObject().subscribe(
      (res) => {
        console.log('onListenDeskAdvanceObject');
        const data = JSON.parse(res);
        console.log(JSON.stringify(data));
        this.currentTurn = data.currentTurn;
        if (this.selectedDesk && this.selectedDesk.internalId === data.deskInternalId) {
          this.currentDeskName = null;
          this.currentWaitingAndAttendingTurns = data.peopleWaiting;
        } else if (this.selectedLocation) {
          const location = data.location;
          this.selectedLocation.name = location.name;
          this.selectedLocation.numeration = location.numeration;
          this.selectedLocation.status = location.status;
          this.selectedLocation.turnAlias = data.currentTurn;
          this.selectedLocation.turnDeskName = data.deskName;
          this.currentDeskName = data.deskName;
          this.currentWaitingAndAttendingTurns = location.sumPeopleWaitingAtItsDesks;
        }
      }
    );

    this.listenUpdateDesksSubscription = this.turnsService.listenUpdateDesks().subscribe(
      (res) => {
        this.getControlDesks();
      }
    );

    this.listenTurnTakenSubscription = this.turnsService.listenTurnTaken().subscribe(
      (res) => {
        if (this.selectedDesk) {
          this.getControlDesks();
        } else if (this.selectedLocation) {
          this.updateCurrentLocation();
        }
      }
    );
  }

  private getControlDesks() {
    this.turnsService.getControlDesks().subscribe(
      (res) => {
        if (this.selectedDesk) {
          const updatedDesk = res.filter(desk => desk.internalId === this.selectedDesk.internalId)[0];
          console.log(JSON.stringify(updatedDesk));
          this.userStorageService.setSelectedDesk(updatedDesk);
          this.selectedDesk = updatedDesk;
          this.currentTurn = (this.selectedDesk.turnPrefix ? this.selectedDesk.turnPrefix : '') + (
            this.selectedDesk.lastCalledTurnAlias ?
              this.selectedDesk.lastCalledTurnAlias :
              this.selectedDesk.lastCalledTurnNumber
          );
          this.currentDeskName = null;
          this.currentWaitingAndAttendingTurns = this.selectedDesk.waitingAndAttendingTurns;
        }
      },
      (error) => {
        console.dir(error);
      }
    );
  }

  private updateCurrentLocation() {
    if (this.selectedLocation) {
      this.turnsService.updateCurrentLocation(this.selectedLocation.internalId).subscribe(
        (res) => {
          console.log('Location updated: ' + JSON.stringify(res));
          this.selectedLocation.name = res.name;
          this.selectedLocation.numeration = res.numeration;
          this.selectedLocation.status = res.status;
          this.selectedLocation.turnAlias = res.turnAlias;
          this.selectedLocation.turnDeskName = res.turnDeskName;
          this.currentTurn = this.selectedLocation.turnAlias;
          this.currentDeskName = this.selectedLocation.turnDeskName;
          this.currentWaitingAndAttendingTurns = res.sumPeopleWaitingAtItsDesks;
          this.checkDeskLocationStatus();
        },
        (error) => {
          console.dir(error);
        }
      );
    }
  }

  openLocation() {
    if (this.selectedLocation) {
      this.turnsService.callOpenDeskLocation(this.selectedLocation.internalId).subscribe(
        (res) => {
          if (res.success) {
            console.log('Location opened');
            this.updateCurrentLocation();
          }
        },
        (error) => {
          console.dir(error);
        }
      );
    }
  }

  closeLocation() {
    if (this.selectedLocation) {
      this.turnsService.callCloseDeskLocation(this.selectedLocation.internalId).subscribe(
        (res) => {
          if (res.success) {
            this.updateCurrentLocation();
          }
        },
        (error) => {
          console.dir(error);
        }
      );
    }
  }

  goToAdmin() {
    this.router.navigate(['/admin']);
  }

  callNextTurn() {
    if (this.selectedLocation) {
      this.turnsService.callNextDeskLocation(this.selectedLocation.internalId).subscribe();
    } else {
      this.turnsService.pushTurn(this.selectedDesk.internalId).subscribe();
    }
  }

  callbackTurn() {
    if (this.selectedLocation) {
      this.turnsService.callbackLastLocationTurn(this.selectedLocation.internalId).subscribe();
    } else {
      this.turnsService.callBackLastTurn(this.selectedDesk.internalId).subscribe();
    }
  }

  requeueTurn() {
    if (this.selectedLocation) {
      this.turnsService.requeueTurn(this.selectedLocation.internalId).subscribe();
    }
  }

  showPendingTurns() {
    this.router.navigate(['/pendingTurns']);
  }

  ngOnDestroy() {
    if (this.listenDeskAdvanceObjectSubscription) { this.listenDeskAdvanceObjectSubscription.unsubscribe(); }
    if (this.listenUpdateDesksSubscription) { this.listenUpdateDesksSubscription.unsubscribe(); }
    if (this.listenTurnTakenSubscription) { this.listenTurnTakenSubscription.unsubscribe(); }
  }

}
